import React, { useState } from 'react'
import { useStyles } from './MenuListButtonGroup.styles'
import { IMenuItem } from 'hooks/useMenu'
import { List } from 'immutable'
import { MenuListButton } from './MenuListButton'

export interface IMenuListButtonGroupProps {
  menuItems: List<IMenuItem>
}

export const MenuListButtonGroup = ({ menuItems }: IMenuListButtonGroupProps) => {
  const classes = useStyles()
  const [openedItem, setOpenedItem] = useState<IMenuItem | null>(null)
  const onOpen = (menuItem: IMenuItem) => setOpenedItem(menuItem)
  const onClose = (menuItem: IMenuItem) => {
    if (openedItem === menuItem) {
      setOpenedItem(null)
    }
  }

  return (
    <div className={classes.root}>
      {menuItems.map((menuItem, index) => (
        <MenuListButton
          key={`menu-item-${index}`}
          menuItem={menuItem}
          onOpen={onOpen}
          onClose={onClose}
          isOpen={menuItem === openedItem}
        />
      ))}
    </div>
  )
}
